'use client'

import { Radio as RadioPrimitive } from '@base-ui/react/radio'

import { cn } from '@/lib/utils'

interface RadioProps<Value = string> extends Omit<RadioPrimitive.Root.Props<Value>, 'children'> {
  size?: 'md' | 'lg'
}

function Radio<Value = string>({ className, size = 'md', ...props }: RadioProps<Value>) {
  return (
    <RadioPrimitive.Root
      data-slot="radio"
      className={(state) =>
        cn(
          'group/radio relative flex shrink-0 cursor-pointer items-center justify-center rounded-round border border-creation-neutral-container-on-surface-default bg-creation-neutral-container-surface-default outline-none focus-visible:shadow-[0_0_8px_4px_var(--color-primary-a30)]',
          size === 'md' ? 'size-6' : 'size-8',
          'data-unchecked:not-data-disabled:hover:border-creation-primary-container-on-surface-hover data-unchecked:not-data-disabled:hover:bg-creation-primary-container-surface-hover',
          'data-unchecked:not-data-disabled:active:border-creation-primary-container-on-surface-pressed data-unchecked:not-data-disabled:active:bg-creation-primary-container-surface-pressed',
          'data-checked:border-0 data-checked:bg-creation-primary-solid-surface-default',
          'data-checked:not-data-disabled:hover:bg-creation-primary-solid-surface-hover data-checked:not-data-disabled:active:bg-creation-primary-solid-surface-pressed',
          'data-disabled:cursor-not-allowed data-unchecked:data-disabled:border-creation-neutral-container-on-surface-disable data-unchecked:data-disabled:bg-creation-neutral-container-surface-disable data-checked:data-disabled:bg-creation-primary-solid-surface-disable',
          typeof className === 'function' ? className(state) : className,
        )
      }
      {...props}
    >
      <span
        aria-hidden
        className={cn(
          'pointer-events-none absolute rounded-round bg-creation-primary-container-on-surface-hover opacity-0 group-data-unchecked/radio:group-hover/radio:opacity-100 group-data-unchecked/radio:group-active/radio:bg-creation-primary-container-on-surface-pressed group-data-disabled/radio:opacity-0!',
          size === 'md' ? 'size-4' : 'size-6',
        )}
      />
      <RadioPrimitive.Indicator
        className={cn(
          'pointer-events-none rounded-round bg-creation-primary-solid-on-surface-default group-data-disabled/radio:bg-creation-primary-solid-on-surface-disable',
          size === 'md' ? 'size-4' : 'size-6',
        )}
      />
    </RadioPrimitive.Root>
  )
}

export { Radio }
export { RadioGroup } from '@base-ui/react/radio-group'
export type { RadioProps }
